module.exports = __webpack_public_path__ + "img/gpuaas-heng.810613e1.png";